import ManualFanMode from "src/consts/ManualFanMode";
import RhSensorEnum from "src/consts/RhSensorEnum";
import TemperatureSensorEnum from "src/consts/TemperatureSensorEnum";
import BinDTO from "src/models/BinDTO";

export const getDefaultTemperatureSensorType = (binDTO: BinDTO): TemperatureSensorEnum => {

    if (binDTO == null) {
        return TemperatureSensorEnum.Thermocouple;
    }

    if (binDTO.temperatureCables?.length) {
        return TemperatureSensorEnum.Thermocouple;
    }
    else if (binDTO.opiMoistureCables?.length) {
        return TemperatureSensorEnum?.Opi;
    }
    else if (binDTO.binSenseMoistureCables?.length) {
        return TemperatureSensorEnum?.BinSense;
    }
    else {
        return TemperatureSensorEnum.PowerCast;
    }
}

export const getDefaultRhSensorType = (binDTO: BinDTO): RhSensorEnum => {

    if (binDTO == null) {
        return RhSensorEnum.Opi;
    }

    if (binDTO.opiMoistureCables?.length) {
        return RhSensorEnum.Opi;
    }
    else if (binDTO.binSenseMoistureCables?.length) {
        return RhSensorEnum.BinSense;
    }
    else {
        return RhSensorEnum.PowerCast;
    }
}

export const getDesiredFanMode = (binDTO: BinDTO | null | undefined) => {
      let convertedMode = ManualFanMode.AutoWeather;
        switch (binDTO?.fanOperations?.desiredFanOn) {
            case true: {
                convertedMode = ManualFanMode.AlwaysOn;
                if (binDTO?.fanOperations?.ignoreWeatherConditions === false) {
                    convertedMode = ManualFanMode.AutoWeather;
                }
                break;
            }
            case false: {
                convertedMode = ManualFanMode.AlwaysOff;
                break;
            }
            case null: {
                convertedMode = ManualFanMode.AutoWeather;
                break;
            }
            default: {
                convertedMode = ManualFanMode.AutoWeather;
                break;
            }
        }
    return convertedMode;
}